<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-img
            width="100%"
            height="100vh"
            alt="amanata"
            class="px-8"
            gradient="to top right, rgba(246, 225, 3, 0.25), rgba(246, 225, 3, 0.25)"
            :src="require('@/assets/background/bg_3.jpg')">
            <v-row 
              align="center" 
              justify="center"
              style="height: 100vh;">
              <v-col 
                cols="12"
                md="3">
                <v-card
                  flat
                  color="transparent">
                  <div>
                    <v-card
                      flat
                      color="#FFFFFFB2"
                      class="border-radius">
                      <v-card-text
                        class="pa-8">
                        <div
                          class="text-center mb-6">
                          <div
                            class="title font-weight-bold black--text mb-2">
                            Masuk Admin
                          </div>
                        </div>

                        <ValidationObserver 
                          ref="observer">
                          <v-form class="text-left mb-6">
                            <ValidationProvider 
                              name="Email" 
                              rules="required|email" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Email"
                                prepend-inner-icon="mdi-email-outline"

                                vv-uppercase

                                v-model="form.username"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="Password" 
                              rules="required|min:5|max:20" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Password"
                                :type="show ? 'text' : 'password'"
                                prepend-inner-icon="mdi-lock-outline"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show = !show"
                                :counter="20"

                                vv-uppercase
                                
                                v-model="form.password"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>
                          </v-form>
                        </ValidationObserver>

                        <div 
                          class="text-center mb-6">
                          <div v-if="message.error.length > 0"
                            class="text-center my-4">
                            <div
                              class="error--text d-flex align-start">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>

                          <v-btn
                            v-on:keyup.enter="save"
                            :disabled="process.form"
                            :loading="process.form"
                            @click="save"
                            block
                            x-large
                            width="170"
                            elevation="0"
                            class="title font-weight-bold white--text text-capitalize"
                            style="border-radius: 10px; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                            Masuk
                          </v-btn>
                        </div>

                        <div
                          class="body-2 text-center black--text">
                          Lupa password ?
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-img>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#7550e1')

              this.$store.commit("setColor", '#7550e1')
            }
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              let user = res.results.data,
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Monitoring',
                      icon: require('@/assets/icon/monitor.png'),
                      link: '/monitoring',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Maping',
                          link: '/monitoring/maping',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Pegawai Presensi (Hari Ini)',
                          link: '/monitoring/attendance',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Pegawai Ijin (Hari Ini)',
                          link: '/monitoring/permission',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Unit',
                      icon: require('@/assets/icon/struktur.png'),
                      link: '/unit',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Struktur Organisasi',
                          link: '/unit/structure',
                          active: false,
                          sub_child: []
                        },
                        // {
                        //   title: 'Data Unit / Divisi',
                        //   link: '/unit/division',
                        //   active: false,
                        //   sub_child: []
                        // },
                        {
                          title: 'Aturan Perusahaan',
                          link: '/unit/rule',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Pegawai',
                      icon: require('@/assets/icon/user.png'),
                      link: '/user',
                      active: true,
                      sub_menu: []
                    },
                    {
                      title: 'Presensi',
                      icon: require('@/assets/icon/absen.png'),
                      link: '/attendance',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Data Presensi',
                          link: '/attendance/presence',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Keterlambatan',
                          link: '/attendance/late',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Rekap Presensi',
                          link: '/attendance/recap',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Lembur',
                      icon: require('@/assets/icon/lembur.png'),
                      link: '/overtime',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Ajuan Lembur',
                          link: '/overtime/proposal',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Riwayat Lembur',
                          link: '/overtime/history',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Informasi Gaji',
                      icon: require('@/assets/icon/gaji.png'),
                      link: '/salary',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Konfigurasi Gaji',
                          link: '/salary/now',
                          active: false,
                          sub_child: [
                            {
                              title: 'Sekarang',
                              link: '/salary/now',
                              active: false
                            },
                            {
                              title: 'Riwayat',
                              link: '/salary/history',
                              active: false
                            }
                          ]
                        },
                        {
                          title: 'Gaji Bulanan',
                          link: '/salary/month',
                          active: false,
                          sub_child: []
                        },
                        // {
                        //   title: 'Riwayat Gaji',
                        //   link: '/salary/history',
                        //   active: false,
                        //   sub_child: []
                        // }
                      ]
                    },
                    {
                      title: 'Reimbursment',
                      icon: require('@/assets/icon/reimburs.png'),
                      link: '/reimbursement',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Kategori',
                          link: '/reimbursement/category',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Plafon',
                          link: '/reimbursement/plafon',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Pengajuan',
                          link: '/reimbursement/submission',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Riwayat',
                          link: '/reimbursement/history',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Perijinan & Cuti',
                      icon: require('@/assets/icon/ijin_menu.png'),
                      link: '/licensing',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Data Sisa Cuti',
                          link: '/licensing/holiday',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Ajuan Ijin & Cuti',
                          link: '/licensing/submission',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Riwayat Ijin & Cuti',
                          link: '/licensing/permission',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Laporan',
                      icon: require('@/assets/icon/laporan.png'),
                      link: '/report',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Data Laporan',
                          link: '/report/data',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Summary Laporan',
                          link: '/report/summary',
                          active: false,
                          sub_child: []
                        },
                      ]
                    },
                    {
                      title: 'Agenda',
                      icon: require('@/assets/icon/event.png'),
                      link: '/event',
                      active: true,
                      sub_menu: []
                    },
                    // {
                    //   title: 'Managemen Arsip',
                    //   icon: require('@/assets/icon/archive.png'),
                    //   link: '/archive',
                    //   active: false,
                    //   sub_menu: [
                    //     {
                    //       title: 'Template',
                    //       link: '/archive/template',
                    //       active: false,
                    //       sub_child: []
                    //     },
                    //     {
                    //       title: 'Folder',
                    //       link: '/archive/folder',
                    //       active: false,
                    //       sub_child: []
                    //     },
                    //   ]
                    // },
                    {
                      title: 'Pengumuman',
                      icon: require('@/assets/icon/pengumuman.png'),
                      link: '/announcement',
                      active: true,
                      sub_menu: []
                    },
                    // {
                    //   title: 'Audit Trail',
                    //   icon: require('@/assets/icon/audit.png'),
                    //   link: '/audit',
                    //   active: true,
                    //   sub_menu: []
                    // },
                    {
                      title: 'Konfigurasi',
                      icon: require('@/assets/icon/setting.png'),
                      link: '/setting',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Perusahaan',
                          icon: require('@/assets/icon/company.png'),
                          link: '/setting/company',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Jabatan',
                          icon: require('@/assets/icon/posisi.png'),
                          link: '/setting/position',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Tipe Dokumen',
                          icon: require('@/assets/icon/doc.png'),
                          link: '/setting/doc',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Gaji',
                          icon: require('@/assets/icon/gaji_config.png'),
                          link: '/setting/salary',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Kategori',
                          icon: require('@/assets/icon/category.png'),
                          link: '/setting/category',
                          active: false,
                          sub_child: []
                        }
                      ]
                    }
                  ]

              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>